import { VBVisible } from './visible';
import { pluginFactory } from '../../utils/plugins';
var VBVisiblePlugin = /*#__PURE__*/pluginFactory({
  directives: {
    VBVisible: VBVisible
  }
});
export { VBVisiblePlugin, VBVisible };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/directives/visible/index.js
// module id = 560
// module chunks = 1